import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import Button from '@ff/ui/Button';
import FlexRow from '@ff/ui/FlexRow';
import Text from '@ff/ui/Text';

export type PaymentMethod = 'cash' | 'lease';

export interface Props {
  paymentMethod: PaymentMethod;
  onPaymentMethodChange: (paymentMethod: PaymentMethod) => void;
}

export default function PaymentOptions({ paymentMethod, onPaymentMethodChange }: Props) {

  return (
    <Box>
      <Message>After confirming the order, then determine the payment method</Message>
      <ButtonContainer>
        <OptionButton
          fullWidth
          active={paymentMethod === 'cash'}
          onClick={() => onPaymentMethodChange('cash')}
        >
          Cash
        </OptionButton>
        <OptionButton
          fullWidth
          active={paymentMethod === 'lease'}
          onClick={() => onPaymentMethodChange('lease')}
        >
          Lease
        </OptionButton>
      </ButtonContainer>
    </Box>
  );
}

const OptionButton = styled(Button)<{ active?: boolean }>(({ active }) => ({
  padding: '4px 6px',
  borderRadius: '4px',
  backgroundColor: active ? 'rgba(250, 250, 250, 1)' : 'rgba(225, 225, 225, 1)',
  '& .ff-ui-button-label': {
    fontSize: '15px',
    lineHeight: '26px',
    fontWeight: 400,
    color: 'rgba(63, 63, 67, 1)',
    textTransform: 'none',
  }
}));

const ButtonContainer = styled(FlexRow)({
  borderRadius: '6px',
  padding: '2px',
  gap: '10px',
  backgroundColor: 'rgba(225, 225, 225, 1)',
  marginTop: '8px',
  marginBottom: '26px',
});

const Message = styled(Text)({
  fontSize: '14px',
  lineHeight: '22px',
  marginTop: '32px',
  color: 'rgba(106, 108, 112, 1)'
});
